const ABSENTEE_BALLOT = "absenteeballot";
const CHECK_REGISTRATION = "checkregistration";
const MEET_THE_CANDIDATES = "meetthecandidates";
const ONLINE = "online";
const PAPER_STEP_1 = "paper-step-1";
const REGISTER_TO_VOTE = "registertovote";
const VOTING_INFORMATION = "votinginformation";

export default {
  ABSENTEE_BALLOT,
  CHECK_REGISTRATION,
  MEET_THE_CANDIDATES,
  ONLINE,
  PAPER_STEP_1,
  REGISTER_TO_VOTE,
  VOTING_INFORMATION
};
